import React, { FC } from 'react';
import { Grid } from '@mui/material';
import { SchemaElement } from '../types/eventsTypes';
import { FieldControl } from './FieldControl';

type FormGeneratorProps = {
  fields: SchemaElement[];
  values: Record<string, unknown>;
  errors: Record<string, unknown>;
  onChange: (name: string, value: unknown) => void;
  /* Tracks control update, that is not yet a value change (eg. input text on autocomplete) */
  onUpdate?: (name: string, value: unknown) => void;
};

export const FormGenerator: FC<FormGeneratorProps> = ({
  fields,
  errors,
  values,
  onChange,
  onUpdate,
}) => (
  <>
    {fields.map(element => {
      if (element.type === 'group') {
        return (
          <Grid key={element.name} item xs={element.width || 12}>
            <FormGenerator
              fields={element.controls}
              errors={errors}
              values={values}
              onChange={onChange}
              onUpdate={onUpdate}
            />
          </Grid>
        );
      }

      const { name, type, label, width, options } = element;

      return (
        <Grid key={name} item xs={width || 12}>
          <FieldControl
            name={name}
            type={type}
            label={label}
            options={options}
            error={(errors as Record<string, unknown>)[name]}
            value={(values as Record<string, unknown>)[name]}
            onChange={onChange}
            onUpdate={onUpdate}
          />
        </Grid>
      );
    })}
  </>
);
